// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReDate from "@mobily/rescript-date/src/ReDate.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ReactIntl from "react-intl";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Intl_Utils$DvmAdminFrontendFr from "../../../../../../intl/Intl_Utils.bs.js";
import * as App_LabeledText$DvmAdminFrontendFr from "../../../../../../common/components/App_LabeledText.bs.js";
import * as Messages_Common$DvmAdminFrontendFr from "../../../../../../intl/messages/Messages_Common.bs.js";
import * as Messages_Orders_Detail$DvmAdminFrontendFr from "../../../../../../intl/messages/orders/Messages_Orders_Detail.bs.js";
import * as Order_Detail_Correct_Box$DvmAdminFrontendFr from "../Order_Detail_Correct_Box.bs.js";
import * as Order_Detail_Types_Order_Type$DvmAdminFrontendFr from "../../../Order_Detail_Types_Order_Type.bs.js";

function Order_Detail_Correct_Order_Content_Fleet(Props) {
  var order = Props.order;
  var color = Props.color;
  var title = Props.title;
  var newestUndeployedCorrection = Props.newestUndeployedCorrection;
  var tooltipHeight = Props.tooltipHeight;
  var intl = ReactIntl.useIntl();
  var checkEmptyString = function (string) {
    return Belt_Option.mapWithDefault(string, undefined, (function (x) {
                  if (x.length > 0) {
                    return x;
                  }
                  
                }));
  };
  var match = Belt_Option.mapWithDefault(newestUndeployedCorrection, [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        ""
      ], (function (x) {
          return [
                  Belt_Option.mapWithDefault(x.orderDate, "", (function (x) {
                          if (ReDate.isSameDay(x, Belt_Option.getWithDefault(order.body.orderOrderDate, new Date(0.0)))) {
                            return "";
                          } else {
                            return " (" + Intl_Utils$DvmAdminFrontendFr.formatDate(intl, x) + ")";
                          }
                        })),
                  Belt_Option.mapWithDefault(checkEmptyString(x.siret), "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(order.body.orderSiret, "")) {
                            return " (" + x + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(checkEmptyString(x.sirenFinalCustomerLLD), "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(order.body.orderSirenFinalCustomer, "")) {
                            return " (" + x + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(x.companyDiscountPercentage, "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(Belt_Option.mapWithDefault(order.budgetBonus, undefined, (function (x) {
                                        return x.orderCompanyDiscount;
                                      })), 0.0)) {
                            return " (" + Intl_Utils$DvmAdminFrontendFr.formatPercent(intl, x) + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(checkEmptyString(x.acquisitionType), "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(order.body.orderAcquisitionType, "")) {
                            return " (" + x + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(checkEmptyString(x.budgetType), "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(Belt_Option.flatMap(order.budgetBonus, (function (x) {
                                        return x.orderBudgetType;
                                      })), "")) {
                            return " (" + x + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(x.newCarRegistrationDate, "", (function (x) {
                          if (ReDate.isSameDay(x, Belt_Option.getWithDefault(order.body.orderRegistrationDate, new Date(0.0)))) {
                            return "";
                          } else {
                            return " (" + Intl_Utils$DvmAdminFrontendFr.formatDate(intl, x) + ")";
                          }
                        })),
                  Belt_Option.mapWithDefault(checkEmptyString(x.newCarRegistrationID), "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(order.body.orderRegistrationId, "")) {
                            return " (" + x + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(x.customerInvoiceDate, "", (function (x) {
                          if (ReDate.isSameDay(x, Belt_Option.getWithDefault(order.body.orderCustomerInvoiceDate, new Date(0.0)))) {
                            return "";
                          } else {
                            return " (" + Intl_Utils$DvmAdminFrontendFr.formatDate(intl, x) + ")";
                          }
                        })),
                  Belt_Option.mapWithDefault(checkEmptyString(x.customerInvoiceNumber), "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(order.body.orderCustomerInvoiceNumber, "")) {
                            return " (" + x + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(x.orderType, "", (function (x) {
                          if (Order_Detail_Types_Order_Type$DvmAdminFrontendFr.toString(x) !== Order_Detail_Types_Order_Type$DvmAdminFrontendFr.toString(Belt_Option.getWithDefault(order.header.orderOrderType, /* SO */0))) {
                            return " (" + Order_Detail_Types_Order_Type$DvmAdminFrontendFr.toString(x) + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(x.renaultInvoiceDate, "", (function (x) {
                          if (ReDate.isSameDay(x, Belt_Option.getWithDefault(order.body.orderRenaultInvoiceDate, new Date(0.0)))) {
                            return "";
                          } else {
                            return " (" + Intl_Utils$DvmAdminFrontendFr.formatDate(intl, x) + ")";
                          }
                        })),
                  Belt_Option.mapWithDefault(x.carSaleAvailibilityDateMADA, "", (function (x) {
                          if (ReDate.isSameDay(x, Belt_Option.getWithDefault(order.body.orderMADADate, new Date(0.0)))) {
                            return "";
                          } else {
                            return " (" + Intl_Utils$DvmAdminFrontendFr.formatDate(intl, x) + ")";
                          }
                        })),
                  Belt_Option.mapWithDefault(x.carSaleAvailibilityDateMADC, "", (function (x) {
                          if (ReDate.isSameDay(x, Belt_Option.getWithDefault(order.body.orderMADCDate, new Date(0.0)))) {
                            return "";
                          } else {
                            return " (" + Intl_Utils$DvmAdminFrontendFr.formatDate(intl, x) + ")";
                          }
                        })),
                  Belt_Option.mapWithDefault(checkEmptyString(x.modelID), "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(order.body.orderModelId, "")) {
                            return " (" + x + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(checkEmptyString(x.versionID), "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(order.body.orderVersionId, "")) {
                            return " (" + x + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(checkEmptyString(x.phase), "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(order.body.orderPhase, "")) {
                            return " (" + x + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(checkEmptyString(x.salesmanName), "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(order.body.orderSalesmanName, "")) {
                            return " (" + x + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(checkEmptyString(x.agentCode), "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(order.body.orderAgentCode, "")) {
                            return " (" + x + ")";
                          } else {
                            return "";
                          }
                        }))
                ];
        }));
  return React.createElement(Order_Detail_Correct_Box$DvmAdminFrontendFr.make, {
              content: Belt_Array.keepMap([
                    Belt_Option.mapWithDefault(tooltipHeight, undefined, (function (x) {
                            return Caml_option.some(React.createElement("div", {
                                            style: {
                                              height: x
                                            }
                                          }));
                          })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Common$DvmAdminFrontendFr.orderType,
                              children: Belt_Option.mapWithDefault(order.header.orderOrderType, "-", Order_Detail_Types_Order_Type$DvmAdminFrontendFr.toString) + match[10]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.orderDateV2,
                              children: Belt_Option.mapWithDefault(order.body.orderOrderDate, "-", (function (param) {
                                      return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                    })) + match[0]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Common$DvmAdminFrontendFr.siret,
                              children: Belt_Option.getWithDefault(order.body.orderSiret, "-") + match[1]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.finalCustomer,
                              children: Belt_Option.getWithDefault(order.body.orderSirenFinalCustomer, "-") + match[2]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Common$DvmAdminFrontendFr.discount,
                              children: Belt_Option.mapWithDefault(Belt_Option.mapWithDefault(order.budgetBonus, undefined, (function (x) {
                                          return x.orderCompanyDiscount;
                                        })), "-", (function (amount) {
                                      return Intl_Utils$DvmAdminFrontendFr.formatPercent(intl, amount);
                                    })) + match[3]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.aquisitionType,
                              children: Belt_Option.getWithDefault(order.body.orderAcquisitionType, "-") + match[4]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Common$DvmAdminFrontendFr.budget,
                              children: Belt_Option.getWithDefault(Belt_Option.flatMap(order.budgetBonus, (function (x) {
                                          return x.orderBudgetType;
                                        })), "-") + match[5]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.registrationDate,
                              children: Belt_Option.mapWithDefault(order.body.orderRegistrationDate, "-", (function (param) {
                                      return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                    })) + match[6]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.registrationNumber,
                              children: Belt_Option.getWithDefault(order.body.orderRegistrationId, "-") + match[7]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.invoiceClient,
                              children: Belt_Option.mapWithDefault(order.body.orderCustomerInvoiceDate, "-", (function (param) {
                                      return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                    })) + match[8]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.invoiceNumber,
                              children: Belt_Option.getWithDefault(order.body.orderCustomerInvoiceNumber, "-") + match[9]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.invoiceDateV2,
                              children: Belt_Option.mapWithDefault(order.body.orderRenaultInvoiceDate, "-", (function (param) {
                                      return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                    })) + match[11]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.madaDate,
                              children: Belt_Option.mapWithDefault(order.body.orderMADADate, "-", (function (param) {
                                      return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                    })) + match[12]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.madcDate,
                              children: Belt_Option.mapWithDefault(order.body.orderMADCDate, "-", (function (param) {
                                      return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                    })) + match[13]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Common$DvmAdminFrontendFr.model,
                              children: Belt_Option.getWithDefault(order.body.orderModelId, "-") + match[14]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Common$DvmAdminFrontendFr.version,
                              children: Belt_Option.getWithDefault(order.body.orderVersionId, "-") + match[15]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Common$DvmAdminFrontendFr.phase,
                              children: Belt_Option.getWithDefault(order.body.orderPhase, "-") + match[16]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Common$DvmAdminFrontendFr.seller,
                              children: Belt_Option.getWithDefault(order.body.orderSalesmanName, "-") + match[17]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Common$DvmAdminFrontendFr.agent,
                              children: Belt_Option.getWithDefault(order.body.orderAgentCode, "-") + match[18]
                            }))
                  ], (function (x) {
                      return x;
                    })),
              color: color,
              title: title
            });
}

var make = Order_Detail_Correct_Order_Content_Fleet;

export {
  make ,
}
/* react Not a pure module */
